// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".some-space[data-v-21b95897] {\n  margin-bottom: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
